<template>
  <v-dialog
    fullscreen
    persistent
    :model-value="maintenanceMode"
  >
    <v-sheet>
      <v-container fluid style="background-color: rgba(34,119,221,1); height: 100vh;">
        <v-row class="text-center fill-height" dense>
          <v-col cols="12" class="align-self-end">
            <div>
              <div class="medium-outlined">
                Self-service
              </div>
              <div class="large-outlined">
                Kiosk
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="text-animation">
              <div style="color: #FFFFFF; font-size: 96px; font-weight: 700;">
                Opening soon
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div style="padding-bottom: 36px;">
              <v-img
                style="height: 500px;"
                class="mx-auto"
                :src="Logo_white"
              />
            </div>
            <div style="color: #FFFFFF; font-size: 64px; line-height: 80px;">
              <div>
                Powered by
              </div>
              <div style="font-weight: 700;">
                Noona
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-dialog>

</template>

<script>
import Logo_white from '../assets/logo_white.svg';
import { useStore } from "../stores/store";

export default {
  name: "MaintenanceModeScreen",
  setup() {
    const store = useStore()
    return {
      Logo_white,
      store
    }
  },
  computed: {
    kiosk() {
      return this.store.kiosk
    },
    maintenanceMode() {
      if(typeof this.kiosk !== 'undefined' && this.kiosk !== null) {
        return this.kiosk.maintenanceMode
      }
      return false
    },
  }
}
</script>

<style scoped>
.text-animation {
  color: transparent;
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-image: linear-gradient(to right, rgba(192,192,192,1) 0%, rgba(255,255,255,1) 5%, rgba(255,255,255,1) 25%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 75%, rgba(255,255,255,1) 95%, rgba(192,192,192,1) 100%);
  background-repeat: repeat;
  animation: blue-animation 45s linear infinite;
  -webkit-animation: blue-animation 45s linear infinite;
}
@keyframes blue-animation {
  to {
    background-position: 1000vh;
  }
}
@-webkit-keyframes blue-animation {
  to {
    background-position: 1000vh;
  }
}

.large-outlined {
  font-size: 144px;
  font-weight: 700;
  text-transform: uppercase;
  color: #FFFFFF;
  line-height: 100%;
}

.medium-outlined {
  font-size: 60px;
  font-weight: 700;
  text-transform: uppercase;
  color: #FFFFFF;
}
</style>